// extracted by mini-css-extract-plugin
export default {"kanbanMain":"KanbanPageMain_kanbanMain__6Lwb8"};